<template>
  <div class="d-flex flex-column">
    <SearchBar v-model="search_filter" :addLink="{ name: 'pros/create'}" />
    <v-list two-line v-if="filtered.length > 0" class="rounded-lg py-0">
      <v-list-item-group 
        v-model="selected"
        multiple 
        @change="onListChange"
        color="primary"
      >
        <template v-for="(pro, index) in filtered">
          <v-divider :key="`divider-${index}`" v-if="index > 0"/>
          <v-list-item :key="pro.pro_id" :ripple="false" :value="pro" :disabled="isDisabled(pro)" >
            <v-list-item-content>
              <v-list-item-title class="d-flex">
                <div>
                  <strong>{{ pro.business_name }}</strong>
                  <v-icon v-if="pro.account_claimed" small color="orange darken-2" class="ml-1">
                    mdi-alpha-c-circle-outline
                  </v-icon>
                </div>
                <div class="ml-auto text-body-2 grey--text">{{ pro.address ? pro.address.city : '' }}</div>
              </v-list-item-title>
              <v-list-item-subtitle class="d-flex">
                <div class="mr-auto">{{ pro.contact_name }}</div>
                <div v-if="isPaused(pro)">
                  <em>{{ pauseMessage(pro) }}</em>  
                </div>
              </v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
        </template>
      </v-list-item-group>
    </v-list>
    <div v-else class="d-flex flex-column align-center mt-6 mb-2">
      <div class="mb-2">No Pros were found matching that criteria.</div>
      <v-icon size="100px" color="yellow darken-2">
        mdi-emoticon-sad-outline
      </v-icon>
    </div> 
  </div>
</template>

<script>
import SearchBar from '@/components/SearchBar'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ProsInput',

  props: {
    value: Array,

    excluded_ids: {
      type: Array,
      default: () => [],
    },
    structure_type: String,
    service: Number,
    zipcode: String,
  },

  components: {
    SearchBar,
  },

  data() {
    return {
      search_filter: '',
      selected: [],
    }
  },
  
  computed: {
    ...mapGetters('referrals', [ 'allPros' ]),

    filtered() {
      let qualified = this.allPros
      if (!this.search_filter) {
        return qualified
      } else {
        const filt = this.search_filter.toLowerCase()
        return qualified.filter(
            pro => pro.business_name.toLowerCase().includes(filt) ||
            pro.contact_name.toLowerCase().includes(filt) ||
            pro.address.city.toLowerCase().includes(filt)
        )
      }
    },
  },
  
  methods: {
    ...mapActions('referrals', ['loadPros']),

    onListChange() {
      this.$emit('input', this.selected)
    },

    isPaused(pro) {
      return pro.partnership_status != 'enabled' || !pro.referrals_enabled
    },

    isExcluded(pro) {
      return this.excluded_ids.includes(pro.pro_id)
    },

    isDisabled(pro) {
      return this.isExcluded(pro) || this.isPaused(pro)
    },

    pauseMessage(pro) {
      if (pro.partnership_status != 'enabled' && !pro.referrals_enabled) return 'Paused: by Both'
      if (pro.partnership_status != 'enabled') return 'Paused: Your Location'
      if (!pro.referrals_enabled) return 'Paused: by Pro'

      return ''
    },
  },

  watch: {
    value(newValue) {
      this.selected = newValue
    }
  },

  async created() {
    this.selected = this.value

    console.log(this.structure_type)
    this.loadPros({
      service_id: this.service,
      structure_type: this.structure_type,
      zipcode: this.zipcode,
    })
  }
}
</script>